
const LIMIT = 3
export default {
  name: 'BaseProfileAuthorOffers',

  props: {
    author: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      posts: [],
      postsCount: 0,
      isLoad: false,
    }
  },

  async fetch() {
    this.isLoad = true

    await this.fetchOffers()

    this.isLoad = false
  },
  methods: {
    async fetchOffers() {
      const { products, countAllPublishedProducts } = await this.$axios.$get(
        `/advertisements/${this.author.id || this.author._id}`,
        {
          params: {
            limit: LIMIT,
            offset: 0,
          },
        }
      )

      this.posts = products
      this.postsCount = countAllPublishedProducts
    },
  },
}
